import { getGowns } from "../../productStore";
import { Fragment } from "react";
import StoreItem from "./StoreItem";
import Header from "../Header&Footer/Header";
import classes from "./StoreItem.module.css";

const Gowns = () => {
  const gowns = getGowns();
  return (
    <Fragment>
      <Header />
      <h1 className="title">Get Quality Gowns</h1>
      <hr />
      <main className="main">
        <ul className={classes.list}>
          {gowns.map((product) => (
            <StoreItem product={product} />
          ))}
        </ul>
      </main>
    </Fragment>
  );
};

export default Gowns;
